import type { DefectCatalogItem } from '../contracts/availableLayers';

import { getCrackmapCatalogDefects } from './crackmapCatalog';

export function mergeCrackmapCatalogDefects(
  defects: readonly DefectCatalogItem[],
  surveyTypes?: readonly string[],
): readonly DefectCatalogItem[] {
  const surveyTypeFilters = (surveyTypes ?? [])
    .map((value) => value.trim().toLowerCase())
    .filter(Boolean);

  const crackmapDefects =
    surveyTypeFilters.length === 0
      ? getCrackmapCatalogDefects()
      : getCrackmapCatalogDefects().filter((defect) =>
          surveyTypeFilters.includes(defect.surveyType.trim().toLowerCase()),
        );

  if (crackmapDefects.length === 0) {
    return defects;
  }

  const bySlug = new Map<string, DefectCatalogItem>();
  for (const defect of defects) {
    bySlug.set(String(defect.slug), defect);
  }
  for (const crackmap of crackmapDefects) {
    bySlug.set(String(crackmap.slug), crackmap);
  }
  return Array.from(bySlug.values());
}
